import {useState} from "react";
import {Link, useMatch, useResolvedPath} from "react-router-dom";
import {useTranslation} from "react-i18next";
import StyledServicesDropdown from "../styledComponents/ServicesDropdown.style";

function ServicesDropdown() {
    const {t} = useTranslation();
    const [open, setOpen] = useState(false);

    const qmPath = useResolvedPath(t('qmConsultingRoute'));
    const fhirPath = useResolvedPath(t('fhirRoute'));
    const isQMActive = useMatch({path: qmPath.pathname, end: true});
    const isFHIRActive = useMatch({path: fhirPath.pathname, end: true});

    const closeOnFocusLeave = (event) => {
        if (!event.currentTarget.contains(event.relatedTarget)) {
            setOpen(false);
        }
    };

    const handleKeyDown = (event) => {
        if (event.key === 'Escape') {
            setOpen(false);
        }
    };

    const handleToggleKeyDown = (event) => {
        if (event.key === 'Enter' || event.key === ' ') {
            event.preventDefault();
            setOpen(c => !c);
        }
    };

    return (
        <StyledServicesDropdown
            $open={open}
            onMouseEnter={() => setOpen(true)}
            onMouseLeave={() => setOpen(false)}
            onBlur={closeOnFocusLeave}
            onKeyDown={handleKeyDown}
        >
            <div
                className={isQMActive || isFHIRActive ? "servicesToggle active" : "servicesToggle"}
                role={'button'}
                tabIndex={0}
                aria-haspopup={'true'}
                aria-expanded={open}
                onClick={() => setOpen(true)}
                onKeyDown={handleToggleKeyDown}
            >
                <h1>{t('navBarHeaderServices')} <span aria-hidden={'true'}>▾</span></h1>
            </div>
            <div className={'servicesMenu'}>
                <Link className={isQMActive ? "active" : ""} to={t('qmConsultingRoute')} onClick={() => setOpen(false)}>
                    <p>{t('navBarHeaderQM')}</p>
                </Link>
                <Link className={isFHIRActive ? "active" : ""} to={t('fhirRoute')} onClick={() => setOpen(false)}>
                    <p>{t('navBarHeaderFHIR')}</p>
                </Link>
            </div>
        </StyledServicesDropdown>
    )
}

export default ServicesDropdown;
